import { withProps } from 'recompose';
import { compose } from 'ramda';

import { PRODUCT_COMPARISON_ANCHOR_PLANS } from 'app/features/landing/productComparison/constants';
import { FREE_TRIAL_PROMPT } from 'app/router/constants/paths';
import LandingRedirect from 'app/router/LandingRedirect';

const LandingFreeTrialPromptRedirect = compose(
  withProps({
    path: PRODUCT_COMPARISON_ANCHOR_PLANS,
    query: `?${FREE_TRIAL_PROMPT}`,
  }),
)(LandingRedirect);

export default LandingFreeTrialPromptRedirect;
